import ESSAY_STATUS from '../../constants/essay-status';
import React from 'react';
import useStudySupportEssays from './use-study-support-essays';

// Exports
// -------

export default function useEssayNotifications() {
  const { data: essays = [] } = useStudySupportEssays();

  const unseenReviews = React.useMemo(() => {
    return essays.filter(
      (request) =>
        request.status === ESSAY_STATUS.reviewed && !request.essay_data.external_info?.acknowledged
    );
  }, [essays]);

  return unseenReviews;
}
